import React from 'react';
import styled from 'styled-components';
import { Colors } from '../../../assets';

interface Props {
  children: string;
  primary?: boolean;
  disabled?: boolean;
  className?: string;
  type?: 'button' | 'submit' | 'reset' | undefined;
  onClick?: () => void;
}

export const SecondaryButton: React.FC<Props> = ({ children, ...props }) => {
  return <StyledButton {...props}>{children}</StyledButton>;
};

const StyledButton = styled.button`
  background: ${Colors.lightGrey};
  border: 2px solid ${Colors.lightGrey};
  border-radius: 4px;
  box-sizing: border-box;
  color: ${Colors.primary};
  cursor: pointer;
  display: inline-block;
  font-size: 16px;
  font-weight: 700;
  line-height: 36px;
  margin: 0;
  min-width: 145px;
  padding: 0 15px;
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: all 0.2s ease !important;
  white-space: nowrap;

  &:hover {
    background: #d7d9db;
    color: ${Colors.primary};
    border-color: #d7d9db;
  }
`;
